/* Custom Reaven — testo della barra annunci per il drop
   (snippets/drop-announcement.liquid).

   Il testo giusto lo calcola gia' il server, ma una pagina lasciata aperta (o
   servita dalla cache) resterebbe sulla frase vecchia: qui si ricontrolla ogni
   30 secondi e si passa da "in uscita il …" a "in uscita oggi" e poi a "online".

   L'orario del lancio e' sempre italiano, per qualunque visitatore: la
   conversione e' la stessa di assets/countdown-timer.js. */
if (!customElements.get('drop-announcement')) {
  customElements.define(
    'drop-announcement',
    class DropAnnouncement extends HTMLElement {
      static TIME_ZONE = 'Europe/Rome';
      static GIORNO = 86400000;

      connectedCallback() {
        const date = (this.dataset.date || '').trim();
        const time = (this.dataset.time || '19:00').trim();
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{1,2}:\d{2}$/.test(time)) return;

        this.launch = DropAnnouncement.zonedTimeToUtc(date, time);
        this.onlineUntil = this.launch + (parseInt(this.dataset.onlineDays, 10) || 0) * DropAnnouncement.GIORNO;
        this.update();
        this.interval = setInterval(() => this.update(), 30000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      /* data "da calendario" italiana, formato AAAA-MM-GG */
      static giornoItaliano(timestamp) {
        return new Intl.DateTimeFormat('en-CA', { timeZone: DropAnnouncement.TIME_ZONE }).format(new Date(timestamp));
      }

      update() {
        const now = Date.now();
        const remaining = this.launch - now;
        const oggi = DropAnnouncement.giornoItaliano(now);
        const domani = DropAnnouncement.giornoItaliano(now + DropAnnouncement.GIORNO);
        const giornoLancio = (this.dataset.date || '').trim();
        let text;
        if (remaining <= 0) text = now < this.onlineUntil ? this.dataset.testoOnline : '';
        else if (giornoLancio === oggi) text = this.dataset.testoOggi;
        else if (giornoLancio === domani) text = this.dataset.testoDomani;
        else text = this.dataset.testoFuturo;

        if (this.textContent.trim() === (text || '').trim()) return;
        this.textContent = text;
        /* finita anche la finestra "online": via la voce dalla barra */
        if (!text) this.closest('span')?.remove();
      }

      /* stessa logica di countdown-timer.js: ora "da calendario" italiana -> timestamp */
      static zonedTimeToUtc(dateStr, timeStr) {
        const [year, month, day] = dateStr.split('-').map(Number);
        const [hour, minute] = timeStr.split(':').map(Number);
        const target = Date.UTC(year, month - 1, day, hour, minute, 0);
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: DropAnnouncement.TIME_ZONE,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false,
        });
        let timestamp = target;
        for (let i = 0; i < 3; i++) {
          const parts = {};
          formatter.formatToParts(new Date(timestamp)).forEach((part) => {
            parts[part.type] = part.value;
          });
          const wallClock = Date.UTC(
            Number(parts.year),
            Number(parts.month) - 1,
            Number(parts.day),
            Number(parts.hour) % 24,
            Number(parts.minute),
            Number(parts.second)
          );
          const diff = target - wallClock;
          if (diff === 0) break;
          timestamp += diff;
        }
        return timestamp;
      }
    }
  );
}
